export const getSkinDisplayRarity = (rarity = 0, name = ''): number => {
  // name has * prefix
  if (name.startsWith('★')) return 8 // display as extraordinary
  return rarity ?? 0
}
